import { observable, runInAction, reaction } from "mobx";

(function () {
  const menuBrowse = document.querySelector(".js-mega-menu"),
    megaMenu = document.querySelector(".mega-menu"),
    nav = document.querySelector(".mega-menu-top"),
    line = document.querySelector(".hover-line"),
    menuItems = Array.from(
      document.querySelectorAll(".mega-menu-top-item[data-menu]")
    );

  // escape hatch
  if (!menuBrowse || !megaMenu) return;

  // init
  let state = observable({
    menuOpen: false,
    activeTab: "topics",
  });

  // reactions
  // 1. open/close menu
  reaction(
    () => state.menuOpen,
    (menuOpen) => {
      if (menuOpen) {
        menuBrowse.classList.add("active");
        megaMenu.style.display = "block";
        line.style.opacity = 1;
        moveLine();
        setTimeout(() => {
          megaMenu.style.opacity = 1;
          line.style.transition = "opacity 0.3s, transform 0.15s";
        }, 10);
      } else {
        megaMenu.style.opacity = 0;
        line.style.opacity = 0;
        setTimeout(() => {
          megaMenu.style.display = "none";
          menuBrowse.classList.remove("active");
        }, 10);
      }
    }
  );
  // 2. change activeTab
  reaction(
    () => state.activeTab,
    (activeTab, previousTab) => {
      const menuOut = megaMenu.querySelector(
          `.mega-menu-group[data-menu="${previousTab}"]`
        ),
        menuIn = megaMenu.querySelector(
          `.mega-menu-group[data-menu="${activeTab}"]`
        );
      moveLine();
      swapMenu(menuOut, menuIn);
    }
  );

  // user actions
  menuBrowse.addEventListener("mouseover", openMenu);
  menuBrowse.addEventListener("keydown", (e) => {
    // press enter or down or spacebar
    if (e.keyCode === 13 || e.keyCode === 40 || e.keyCode === 32) {
      openMenu({ e, focus: true });
    }
  });
  [menuBrowse, megaMenu].forEach((el) => {
    el.addEventListener("mouseout", (e) => {
      if (
        e.relatedTarget?.closest(".mega-menu") ||
        e.relatedTarget?.closest(".js-mega-menu")
      )
        return;
      closeMenu();
    });
  });
  menuItems.forEach((trigger) => {
    const setMenuTab = () =>
      runInAction(() => {
        state.activeTab = trigger.dataset.menu;
      });
    trigger.addEventListener("mouseenter", setMenuTab);
    trigger.addEventListener("focus", setMenuTab);
  });
  megaMenu.addEventListener("click", (e) => e.stopPropagation());
  megaMenu.addEventListener("keydown", (e) => {
    // press down arrow or spacebar
    if (e.keyCode === 40 || e.keyCode === 32) {
      e.preventDefault();
      megaMenu
        .querySelector(`.mega-menu-group[data-menu="${state.activeTab}"]`)
        ?.querySelector('[href]:not([tabindex="-1"])')
        ?.focus();
    }
    // escape
    if (e.keyCode === 27) {
      closeMenu();
    }
  });

  // functions
  function openMenu({ e = null, focus = false }) {
    runInAction(() => (state.menuOpen = true));

    if (e) e.preventDefault();
    if (focus) nav.querySelector(`[data-menu="${state.activeTab}"]`)?.focus();
  }
  function closeMenu() {
    runInAction(() => (state.menuOpen = false));
  }
  function moveLine() {
    const activeItem = menuItems.find(
        (item) => item.dataset.menu === state.activeTab
      ),
      text = activeItem.querySelector("span"),
      textCoords = text.getBoundingClientRect(),
      navCoords = nav.getBoundingClientRect();

    const coords = {
      width: textCoords.width,
      top: textCoords.top - navCoords.top + 22,
      left: textCoords.left - navCoords.left,
    };
    line.style.width = `${coords.width}px`;
    line.style.transform = `translate(${coords.left}px, ${coords.top}px)`;
  }
  function swapMenu(menuOut, menuIn) {
    menuOut.style.opacity = 0;
    menuIn.style.display = "block";

    setTimeout(() => {
      menuOut.style.display = "none";
      menuIn.style.opacity = 1;
    }, 10);
  }
})();
